import type {
    TaskCheckPayload,
    TaskCheckResponse,
} from '@/types/apps/task-check.type';
import type { ApiResponse } from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';

export class TaskCheckV2Service {
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        createTaskInDevice: () =>
            '/api/v2/task-check/create-ticket-with-task-check',
    };

    public createTaskInDevice(
        payload: TaskCheckPayload
    ): Promise<ApiResponse<TaskCheckResponse>> {
        return this.apiClient.postApi(
            this.endpoints.createTaskInDevice(),
            payload
        );
    }
}
